import React, { useEffect, useState } from 'react';
import { getReportFullHtml, openPrintWindow } from '../utils/exportUtils';
import { getThreadReportForPreview } from '../utils/correspondencePrint';

/**
 * Modal showing thread report preview with Close, Open in New Tab, and Open print preview (new tab with Print controls).
 */
const ThreadReportPreviewModal = ({ chain, project, entries, onClose }) => {
  const [blobUrl, setBlobUrl] = useState(null);

  useEffect(() => {
    const { bodyHtml, title } = getThreadReportForPreview({ chain, project, entries });
    if (!bodyHtml) return;
    const html = getReportFullHtml({ title, subtitle: '', bodyHtml, includePrintControls: false });
    const blob = new Blob([html], { type: 'text/html' });
    const url = URL.createObjectURL(blob);
    setBlobUrl(url);
    return () => {
      try { URL.revokeObjectURL(url); } catch (_) {}
    };
  }, [chain, project, entries]);

  const handleOpenInNewTab = () => {
    const { bodyHtml, title } = getThreadReportForPreview({ chain, project, entries });
    if (!bodyHtml) return;
    const win = window.open('', '_blank');
    if (win) {
      win.document.write(getReportFullHtml({ title, subtitle: '', bodyHtml, includePrintControls: true }));
      win.document.close();
    }
  };

  const handleOpenPrintPreviewTab = () => {
    const { bodyHtml, title } = getThreadReportForPreview({ chain, project, entries });
    if (!bodyHtml) return;
    openPrintWindow({ title, subtitle: '', bodyHtml });
  };

  const { bodyHtml } = getThreadReportForPreview({ chain, project, entries });

  if (!chain || !bodyHtml) return null;

  return (
    <div className="modal-overlay">
      <div className="modal-content" style={{ maxWidth: 920 }}>
        <div className="modal-header">
          <h2>Thread Report Preview</h2>
          <button className="btn-close" onClick={onClose}>
            <svg viewBox="0 0 20 20" fill="currentColor">
              <path fillRule="evenodd" d="M4.293 4.293a1 1 0 011.414 0L10 8.586l4.293-4.293a1 1 0 111.414 1.414L11.414 10l4.293 4.293a1 1 0 01-1.414 1.414L10 11.414l-4.293 4.293a1 1 0 01-1.414-1.414L8.586 10 4.293 5.707a1 1 0 010-1.414z" clipRule="evenodd" />
            </svg>
          </button>
        </div>
        <div className="modal-body">
          <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 16, marginBottom: 16 }}>
            <div><p style={{ fontSize: 12, color: '#6b7280' }}>Correspondence Subject</p><p style={{ fontSize: 14 }}>{chain.subject || '-'}</p></div>
            <div><p style={{ fontSize: 12, color: '#6b7280' }}>Project</p><p style={{ fontSize: 14 }}>{project?.name || '-'}</p></div>
            <div><p style={{ fontSize: 12, color: '#6b7280' }}>Category</p><p style={{ fontSize: 14 }}>{chain.category || 'General'}</p></div>
            <div><p style={{ fontSize: 12, color: '#6b7280' }}>Status</p><p style={{ fontSize: 14 }}>{chain.status || '-'}</p></div>
          </div>
          <div
            style={{
              border: '1px solid #e5e7eb',
              borderRadius: 8,
              overflow: 'hidden',
              maxHeight: 480,
              minHeight: 360,
              background: '#f9fafb',
            }}
          >
            {blobUrl ? (
              <iframe
                src={blobUrl}
                title="Thread Report"
                style={{ width: '100%', height: 460, border: 'none' }}
              />
            ) : (
              <div style={{ padding: 24, textAlign: 'center', color: '#6b7280' }}>Loading preview...</div>
            )}
          </div>
          <div className="modal-actions" style={{ marginTop: 16 }}>
            <button className="btn-secondary" onClick={onClose}>Close</button>
            <button className="btn-secondary" onClick={handleOpenInNewTab}>Open in New Tab</button>
            <button className="btn-primary" onClick={handleOpenPrintPreviewTab}>Open print preview</button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ThreadReportPreviewModal;
